import type { JSX } from 'react'
import type { IDropdownItemsGroupProps } from '../DropdownItemsGroup'

import { DropdownItemsGroup } from '../DropdownItemsGroup'
import { DropdownItemsGroupPaddings } from '../DropdownItemsGroup.h'

export interface IDropdownItemsGroupSeasonsProps extends IDropdownItemsGroupProps {}

export const DropdownItemsGroupSeasons = ({
  height = 320,
  paddings = DropdownItemsGroupPaddings.SIZE_20,
  children,
  ...rest
}: IDropdownItemsGroupSeasonsProps): JSX.Element => (
  <DropdownItemsGroup height={height} paddings={paddings} {...rest}>
    {children}
  </DropdownItemsGroup>
)
